// Motion configuration to disable animations globally
// This will make all framer-motion animations instant

export const motionConfig = {
  // Disable all animations by setting duration to 0
  transition: { duration: 0 },
  
  // Override common animation properties
  initial: false,
  animate: false,
  exit: false,
  
  // For AnimatePresence
  mode: 'sync'
};

// Alternative: Set reduced motion preference
export const setReducedMotion = () => {
  // This will disable all CSS transitions and animations as well
  const style = document.createElement('style');
  style.textContent = `
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  `;
  document.head.appendChild(style);
};

// Framer Motion global config to disable animations
export const disableFramerMotion = () => {
  // Set the global motion config to disable animations
  if (typeof window !== 'undefined') {
    window.__FRAMER_MOTION_DISABLE_ANIMATIONS__ = true;
  }
};
